import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface SectionShellProps extends PropsWithChildren {
  id: string
  className?: string
  labelledBy?: string
}

export function SectionShell({ id, className, labelledBy, children }: SectionShellProps) {
  return (
    <section
      id={id}
      aria-labelledby={labelledBy}
      className={cn('mx-auto w-full max-w-page px-5 sm:px-8', className)}
    >
      {children}
    </section>
  )
}
